import { useEffect, useState } from "react";
/**
 * KTK-384 — observe the resolved theme for components that can't style
 * purely through CSS tokens (e.g. the syntax highlighter, whose color set
 * is a JS object picked at render time).
 *
 * The HTML root's `data-theme` attribute is the single source of truth
 * (written pre-mount by index.html, after mount by ThemeToggle). This hook
 * mirrors it into React state via a MutationObserver, so a theme flip
 * re-renders subscribers without a page reload. Nearest-ancestor overrides
 * (e.g. a wrapper pinning `data-theme="dark"`) are not visible to this
 * hook — pass an explicit theme prop in those scopes instead.
 */
export function useThemeMode() {
    const read = () => typeof document !== "undefined" &&
        document.documentElement.getAttribute("data-theme") === "light"
        ? "light"
        : "dark";
    const [mode, setMode] = useState(read);
    useEffect(() => {
        const observer = new MutationObserver(() => setMode(read()));
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ["data-theme"],
        });
        return () => observer.disconnect();
    }, []);
    return mode;
}
//# sourceMappingURL=useThemeMode.js.map